/* template */
<template minapp="mpx" xlang="wxml"><div class="coupon-banner-container" v-if="(isShowCoupon)"><card-frame :style="[(backStyle)] | transRpxStyle" :cardConf="(cardConf)" @clickExtra="clickExtra" class="card-frame"><banner :activityId="(activityId)" :newCoustomer="(newCoustomer)" :couponList="(allCoupons)" @clickExtra="clickExtra"/></card-frame><drawer-frame :title="(title)" :useTab="(useTab)" :curTab="(curTab)" :showPackDetail="(showPackDetail)" :leftTitle="(true)" :open="(openDrawer)" :customStyle="(drawerCusStyle)" @closeDrawer="closeDrawer" @changeCurTab="changeCurTab" @hidePackDetail="changeShowPackDetail"><mpx-view slot="titleSlot" @tap="clickCouponRules" class="explain">规则说明</mpx-view><coupon-list :received="(received)" :unclaimed="(unclaimed)" :activityId="(activityId)" :bannerFrom="(bannerFromConf.home)" v-if="(showCouponTab)"/><package-list :bannerFrom="(bannerFromConf.home)" @showPackDetail="changeShowPackDetail" v-else-if="(!showCouponTab && !showPackDetail)"/><package-usage-list v-else/></drawer-frame></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m49abbe6a"}'>
  .card-frame
    background #fff
    font-weight 600
    border-radius 16px
  .explain
    font-size 14px
    color #F86316
    font-weight 500
    margin-left 6px
    position relative
    &::after
      content ''
      top 9px
      right -8px
      position absolute
      width 4px
      height 4px
      border-top 1.5px solid
      border-right 1.5px solid
      transform rotate(45deg)
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m49abbe6a"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex49abbe6a%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex49abbe6a%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m49abbe6a"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index49abbe6a/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'coupon-list':getComponent(require("../coupon-list/index.mpx?isComponent&outputPath=components%2Findex02fdd348%2Findex")),'card-frame':getComponent(require("../../card-frame/index.mpx?isComponent&outputPath=components%2Findexf4806b60%2Findex")),'drawer-frame':getComponent(require("../drawer-frame/index.mpx?isComponent&outputPath=components%2Findex5c33f4ce%2Findex")),'banner':getComponent(require("./banner/index.mpx?isComponent&outputPath=components%2Findex3db8f185%2Findex")),'package-list':getComponent(require("../../package/package-list.mpx?isComponent&outputPath=components%2Fpackage-list51770c4b%2Findex")),'package-usage-list':getComponent(require("../../package/package-usage-list.mpx?isComponent&outputPath=components%2Fpackage-usage-list0aa0f277%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
